import { render, staticRenderFns } from "./Ingredients.vue?vue&type=template&id=58969daa&scoped=true"
import script from "./Ingredients.vue?vue&type=script&lang=ts"
export * from "./Ingredients.vue?vue&type=script&lang=ts"
import style0 from "./Ingredients.vue?vue&type=style&index=0&id=58969daa&prod&scoped=true&lang=css"
import style1 from "./Ingredients.vue?vue&type=style&index=1&id=58969daa&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58969daa",
  null
  
)

export default component.exports